


























































































































































































































import Vue from "vue";
import Component from "vue-class-component";
import TextMonthChangePicker from "./TextMonthChangePicker.vue";
import {
  SearchCondition,
  zenkana2Hankana,
  hiraToKana,
  parseComma
} from "@/types";
import { Prop, Emit, Watch } from "vue-property-decorator";

export type CallbackItemStatus = (value: StringKeyObject) => number;
export type CallbackItemClass = (value: StringKeyObject) => string;
export interface StringKeyObject {
  [key: string]: object;
}

@Component({
  components: {
    TextMonthChangePicker
  }
})
export default class BaseTable extends Vue {
  @Prop({ default: "" }) yearmonth!: string;

  @Prop() btnText!: string;

  @Prop({ default: "" }) btnText2!: string;

  @Prop({ default: "" }) btnText3!: string;

  @Prop({ default: "mdi-page-next-outline" }) btnIcon!: string;

  @Prop({ default: "明細データ確定" }) checkText!: string;

  @Prop() items!: StringKeyObject[];

  @Prop() headers!: object[];

  @Prop({ default: true }) useChecked!: boolean;

  @Prop({ default: false }) btn1Disable!: boolean;
  @Prop({ default: false }) btn2Disable!: boolean;
  @Prop({ default: false }) btn3Disable!: boolean;

  @Prop({ default: true }) allUndetermined!: boolean;
  @Prop({ default: true }) needInsuranceName!: boolean;
  @Prop({ default: true }) needInsuranceNo!: boolean;
  @Prop({ default: true }) needUserKana!: boolean;
  @Prop({ default: true }) needUserCode!: boolean;
  @Prop({ default: true }) needUserInsNo!: boolean;

  @Prop({ default: false }) interbank!: boolean;

  @Prop({ type: Function, required: false })
  callbackItemStatus?: CallbackItemStatus;

  @Prop({ type: Function, required: false })
  callbackItemClass?: CallbackItemClass;

  // セッションストレージ保存キー
  @Prop({ default: "", required: false }) storageKeyItemChecks!: string;

  private searchCondition: SearchCondition = {
    isDone: true,
    insuranceNo: "",
    insuranceName: "",
    userCode: "",
    userKana: "",
    userInsNo: ""
  };

  private selectItems: StringKeyObject[] = [];
  private sortBy: string[] = [];
  private sortDesc: boolean[] = [];
  private isFixed = false;

  private filterWord = "";

  private get position() {
    if (this.isFixed) {
      return "fixed";
    } else {
      return "initial";
    }
  }

  public SelectedItems() {
    const ret: StringKeyObject[] = [];
    if (!this.datatable) {
      return ret;
    }
    // 表示順で、一覧のIDを取得
    const ids: number[] = [];
    const elems = this.datatable.getElementsByClassName(
      "hidden-identification"
    );
    for (let i = 0; i < elems.length; i++) {
      const elm = elems[i];
      const num = Number(elm.textContent);
      if (!isNaN(num)) {
        ids.push(num);
      }
    }

    // 表示順の選択ID一覧作成
    ids.forEach(id => {
      // 選択中のitem取得
      this.selectItems.forEach(item => {
        if (id == Number(item.id)) {
          ret.push(item);
        }
      });
    });
    return ret;
  }

  private datatable: HTMLElement | null = null;
  private spacer: HTMLElement | null = null;
  private conditionArea: HTMLElement | null = null;
  private datatableWrapper: HTMLElement | null = null;
  private table: HTMLElement | null = null;
  private theads: HTMLElement[] = [];
  private normalWidths: string[] = [];
  private fixWidths: string[] = [];
  private tableMarginTop = 0;

  mounted() {
    this.initField();
  }

  beforeDestroy() {
    window.onresize = null;
    window.onscroll = null;
    if (this.datatableWrapper != null) {
      this.datatableWrapper.onscroll = null;
    }
  }

  public updateBaseTable() {
    if (this.table && this.datatableWrapper && this.theads.length > 0) {
      //内容に合わせて、fix時ヘッダーの幅取得
      this.getWidthFixHeader();
      this.adjustTable();

      //スクロール時
      window.onscroll = () => {
        this.scrollHeader();
        this.adjustTable();
      };

      //リサイズ時
      window.onresize = () => {
        this.initField();
        this.getWidthFixHeader();
        this.adjustTable();
      };

      //横スクロール時
      this.datatableWrapper.onscroll = () => {
        this.scrollHeader();
      };
    }
  }

  //テーブルの高さを調整する
  private adjustTable() {
    if (
      this.datatable == null ||
      this.datatableWrapper == null ||
      this.table == null ||
      this.spacer == null ||
      this.conditionArea == null ||
      this.theads.length == 0
    ) {
      return;
    }

    const windowHeight = window.innerHeight;
    const windowWidth = window.innerWidth;
    const scrollTop = window.scrollY;
    const conditionHeight = this.conditionArea.clientHeight + 16;
    const tableHeight = this.table.clientHeight;

    if (scrollTop > conditionHeight - 88) {
      if (!this.isFixed) {
        this.setWidthFixHeader();
        this.isFixed = true;
      }
    } else {
      if (this.isFixed) {
        this.setWidthNormalHeader();
        this.isFixed = false;
      }
    }

    let headerLength = 56;
    if (windowWidth > 960) {
      headerLength += 8;
    }
    let baseHeight = headerLength + 12 + 16 + 12 + 9;

    this.adjustTableMarginTop();
    if (this.isFixed) {
      baseHeight += 48;
      this.table.style.marginTop = `${this.tableMarginTop}px`;
    } else {
      this.table.style.marginTop = "0px";
    }

    const nowHeight = windowHeight - conditionHeight - baseHeight + scrollTop;
    if (nowHeight < tableHeight) {
      this.datatable.style.height = nowHeight + "px";
      this.spacer.style.height = tableHeight - nowHeight + "px";
    } else {
      this.datatable.style.height = "auto";
      this.spacer.style.height = "0px";
    }
  }

  private adjustTableMarginTop() {
    if (this.table) {
      this.theads = [].slice.call(this.table.getElementsByTagName("thead"));
    }
    this.tableMarginTop = 0;
    if (this.theads.length > 1) {
      for (let i = 0; i < this.theads.length - 1; i++) {
        this.tableMarginTop += this.theads[i].getBoundingClientRect().height;
      }
    }
  }

  //ヘッダーを横スクロールする
  private scrollHeader() {
    if (this.datatableWrapper) {
      for (let i = 0; i < this.theads.length; i++) {
        this.theads[i].scrollLeft = this.datatableWrapper.scrollLeft;
      }
    }
  }

  //固定ヘッダーの幅を設定する
  private setWidthFixHeader() {
    let top = 0;
    for (let i = 0; i < this.theads.length; i++) {
      this.theads[i].style.marginTop = `${top}px`;
      top = this.theads[i].getBoundingClientRect().height;
      const thgroup = this.theads[i].children[0] as HTMLElement;
      thgroup.style.display = "inline-block";
      thgroup.style.width = "max-content";
      for (let index = 0; index < this.fixWidths.length; index++) {
        const th = thgroup.children[index] as HTMLElement;
        if (th && thgroup.children.length === this.fixWidths.length) {
          th.style.width = this.fixWidths[index];
        }
      }
    }
  }

  //固定ヘッダーの幅を所得する
  private getWidthFixHeader() {
    if (this.table && this.theads.length > 0 && this.datatableWrapper) {
      //ヘッダーの幅調整
      for (let i = 0; i < this.theads.length; i++) {
        this.theads[i].style.width = this.datatableWrapper.clientWidth + "px";
      }

      //固定ヘッダーの幅取得 && 固定ヘッダー時のtbodyの幅設定
      const tbody = this.table.getElementsByTagName("tbody")[0];
      if (!tbody) {
        return;
      }
      const tdgroup = tbody.children[0];
      this.fixWidths = [];
      for (let index = 0; index < this.normalWidths.length; index++) {
        const td = tdgroup.children[index] as HTMLElement;
        if (td && tdgroup.children.length == this.normalWidths.length) {
          td.style.width = this.normalWidths[index];
          td.style.minWidth = this.normalWidths[index];
          this.fixWidths.push(td.clientWidth + "px");
        }
      }
    }
  }

  //通常ヘッダーの幅を設定する
  private setWidthNormalHeader() {
    for (let i = 0; i < this.theads.length; i++) {
      this.theads[i].style.marginTop = "0px";
      const thgroup = this.theads[i].children[0] as HTMLElement;
      thgroup.style.display = "";
      thgroup.style.width = "";
      for (let index = 0; index < this.normalWidths.length; index++) {
        const th = thgroup.children[index] as HTMLElement;
        if (th && thgroup.children.length === this.normalWidths.length) {
          th.style.width = this.normalWidths[index];
        }
      }
    }
  }

  //変数elementを設定する
  private initField() {
    this.datatable = window.document.getElementById("data-table");
    this.spacer = window.document.getElementById("spacer");
    this.conditionArea = window.document.getElementById("condition-area");
    if (this.datatable && this.spacer && this.conditionArea) {
      this.datatableWrapper = this.datatable
        .firstElementChild as HTMLElement | null;
      if (this.datatableWrapper) {
        this.table = this.datatableWrapper
          .firstElementChild as HTMLElement | null;
        if (this.table) {
          this.theads = [].slice.call(this.table.getElementsByTagName("thead"));
          if (this.theads.length > 0) {
            const thgroup = this.theads[this.theads.length - 1].children[0];
            this.normalWidths = [];
            for (let index = 0; index < thgroup.children.length; index++) {
              const th = thgroup.children[index] as HTMLElement | null;
              if (th) {
                this.normalWidths.push(th.style.width);
              }
            }
          }
        }
      }
    }
  }

  @Emit()
  private search(): SearchCondition {
    return this.searchCondition;
  }

  @Emit()
  private edit(item: object): object {
    return item;
  }

  //並び替えをした選択アイテム配列
  private get filterSelectItems() {
    if (this.sortBy.length < 1) {
      return this.selectItems;
    }
    const col = this.sortBy[0];
    const desc = this.sortDesc[0];
    const newArray: StringKeyObject[] = this.selectItems.slice(
      0,
      this.selectItems.length
    );
    newArray.sort((x: StringKeyObject, y: StringKeyObject) => {
      if (desc) {
        if (x[col] < y[col]) {
          return 1;
        } else if (x[col] == y[col]) {
          return 0;
        } else {
          return -1;
        }
      } else {
        if (x[col] < y[col]) {
          return -1;
        } else if (x[col] == y[col]) {
          return 0;
        } else {
          return 1;
        }
      }
    });
    return newArray;
  }

  private done() {
    if (this.confirmAllSelect()) {
      this.$emit("done", this.filterSelectItems);
    }
  }

  private done2() {
    if (this.confirmAllSelect()) {
      this.$emit("done2", this.filterSelectItems);
    }
  }

  private done3() {
    if (this.confirmAllSelect()) {
      this.$emit("done3", this.filterSelectItems);
    }
  }

  private checked() {
    if (this.confirmAllSelect()) {
      this.$emit("checked", this.selectItems);
    }
  }

  private cancel() {
    if (this.confirmAllSelect()) {
      this.$emit("cancel", this.selectItems);
    }
  }

  private interbankFormat() {
    //チェックが0個の場合
    if (this.selectItems.length === 0) {
      //引落だけにチェックをつける
      if (
        confirm(
          "チェックがついていません。表示されている全てを対象に処理を行いますか？"
        )
      ) {
        this.selectItems = this.items.filter(item => {
          return (item as any).payment_method === "引落";
        });
      }
    }
    this.$emit("interbankFormat", this.selectItems);
  }

  get innerYearmonth(): string {
    return this.yearmonth;
  }

  set innerYearmonth(newValue) {
    this.$emit("update:yearmonth", newValue);
  }

  public setSearchCondition(searchCondition: SearchCondition) {
    this.searchCondition = searchCondition;
  }

  public getSearchCondition(): SearchCondition {
    return this.searchCondition;
  }

  public refreshSelectItem() {
    this.selectItems = [];
  }

  public confirmAllSelect(): boolean {
    if (this.selectItems.length === 0) {
      if (
        confirm(
          "チェックがついていません。表示されている全てを対象に処理を行いますか？"
        )
      ) {
        this.selectItems = this.items;
        return true;
      }
      return false;
    }
    return true;
  }

  @Watch("filterWord")
  public handle() {
    // console.log("pagenation");
    this.$nextTick(() => {
      this.getWidthFixHeader();
      this.adjustTable();
    });
  }

  private customFilter(value: any, search: string | null, item: any) {
    return (
      value != null &&
      search != null &&
      typeof value === "string" &&
      zenkana2Hankana(hiraToKana(value.replaceAll(" ", ""))).indexOf(
        zenkana2Hankana(hiraToKana(search.replaceAll(" ", "")))
      ) !== -1
    );
  }

  //-------------------------------
  // 行の状態（ボタン）
  //-------------------------------
  private itemStatus(item: StringKeyObject) {
    if (!this.callbackItemStatus) {
      // callbackが未登録の場合は、is_printedのみで判定
      if (!item.is_printed) {
        return 0;
      } else {
        return 1;
      }
    }
    return this.callbackItemStatus(item);
  }

  //-------------------------------
  // 行の状態（背景）
  //-------------------------------
  private itemClass(item: StringKeyObject) {
    if (!this.callbackItemClass) {
      return;
    }
    return this.callbackItemClass(item);
  }

  //-------------------------------
  // 日本円表示（フォーマット ¥1,000,000）
  //-------------------------------
  private parseYen(num: number) {
    return `¥${parseComma(num)}`;
  }

  //------------------------------------------
  // アイテムのチェック状態が変更になったイベント
  //------------------------------------------
  private onItemChecked(items: any[]) {
    this.saveStorage(items);
  }
  //------------------------------------------
  // チェック状態解除
  //------------------------------------------
  public clearAllCheck() {
    this.selectItems.splice(0);
    this.removeStorage();
  }
  //------------------------------------------
  // 検索条件セッションストレージ削除メソッド
  //------------------------------------------
  private removeStorage() {
    if (this.storageKeyItemChecks === "") {
      return;
    }
    sessionStorage.removeItem(this.storageKeyItemChecks);
  }
  //------------------------------------------
  // 検索条件セッションストレージ保存メソッド
  //------------------------------------------
  private saveStorage(items: any[]) {
    if (this.storageKeyItemChecks === "") {
      return;
    }
    const ids: number[] = [];
    items.forEach(elm => {
      ids.push(elm.id);
    });
    if (ids.length === 0) {
      this.removeStorage();
      return;
    }
    sessionStorage.setItem(this.storageKeyItemChecks, ids.toString());
  }
  //------------------------------------------
  // 検索条件セッションストレージ復帰メソッド
  //------------------------------------------
  public restoreStorage() {
    if (this.storageKeyItemChecks === "") {
      return;
    }
    const str = sessionStorage.getItem(this.storageKeyItemChecks);
    if (str == null || str == "") {
      return;
    }
    let ids: number[] = [];
    if (str) {
      ids = str.split(",").map(Number);
    }
    this.refreshSelectItem();
    this.items.forEach(elm => {
      ids.forEach(n => {
        if ((elm.id as any) == n) {
          this.selectItems.push(elm);
        }
      });
    });
  }
}
